import { AppState } from "@pmis3/data-access";
import { OrganizationState, OrganizationStateStatus } from "../reducer/organization.reducer";
import { createSelector } from "@ngrx/store";

export const organizationState = (state: AppState) => state.organizationState;

// export const selectOrganizations = createSelector(
//     organizationState,
//     (state: OrganizationState) => state.organizations
// )

export const selectOrganizationStateStatus = createSelector(
  organizationState,
  (state: OrganizationState) => state.status
)

// export const selectOrganizationTypes = createSelector(
//   organizationState,
//   (state: OrganizationState) => {
//     console.log("organization types in state: ", state.organizationTypes)
//     return state.organizationTypes}
// )